import { render, staticRenderFns } from "./MobileAppMenu.vue?vue&type=template&id=56cb4a1c&scoped=true"
import script from "./MobileAppMenu.vue?vue&type=script&lang=js"
export * from "./MobileAppMenu.vue?vue&type=script&lang=js"
import style0 from "./MobileAppMenu.vue?vue&type=style&index=0&id=56cb4a1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb4a1c",
  null
  
)

export default component.exports